import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import _ from 'lodash';
import { PlaceOrderUrl, GetOrdersUrl, CancelOrderUrl, ChangeOrderUrl } from '../constants';
import { transformForApi, transformFromApi, transformOrderForApi } from '..';
import dayjs from 'dayjs';
var httpOptions = {
  headers: {
    Accept: 'application/json'
  }
};

var _create = function create(api) {
  return function (orderDesc) {
    var order = transformForApi(orderDesc);
    return api.authenticated().post(PlaceOrderUrl, order, httpOptions);
  };
};

export { _create as create };

var _change = function change(api) {
  return function (orderDesc) {
    var order = transformOrderForApi(orderDesc);
    return api.authenticated().post(ChangeOrderUrl, order, httpOptions);
  };
};

export { _change as change };

var _cancel = function cancel(api) {
  return function (orderId, accountId) {
    // might need to pass subaccountId, clientRefId params at some point: https://ny4staging.tradingblock.com/RestHub/swagger-ui#/Orders/CancelOrder
    var data = {
      orderId: orderId,
      accountId: accountId
    };
    return api.authenticated().post(CancelOrderUrl, data, httpOptions);
  };
};

export { _cancel as cancel };
export var getOrders = function getOrders(api) {
  return function (options) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var request, optionValues, apiResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // remove blockId from request & format dates dayjs(options.dateFrom).utc().toDate()
              request = _.omit(options, ['blockId']);
              optionValues = Object.assign({}, request, {
                dateFrom: request.dateFrom ? dayjs(request.dateFrom).utc().toDate() : undefined,
                dateTo: request.dateTo ? dayjs(request.dateTo).utc().toDate() : undefined
              });
              _context.next = 4;
              return api.authenticated().get(GetOrdersUrl, optionValues, httpOptions);

            case 4:
              apiResponse = _context.sent;
              return _context.abrupt("return", Object.assign({}, apiResponse, {
                payload: apiResponse.payload ? Object.assign({}, apiResponse.payload, {
                  items: _.map(apiResponse.payload.items, transformFromApi)
                }) : undefined
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
export function order(api) {
  var _this2 = this;

  return function (accountId, subaccountId) {
    return {
      change: function change(req) {
        return tslib_1.__awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _change(api)(req);

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      },
      create: function create(orderDesc) {
        return tslib_1.__awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", _create(api)(Object.assign({}, orderDesc, {
                    AccountId: accountId,
                    kind: 'order'
                  })));

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
      },
      get: function get(request) {
        return tslib_1.__awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4() {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", getOrders(api)(Object.assign({}, request, {
                    accountId: accountId,
                    subaccountId: subaccountId
                  })));

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));
      },
      cancel: function cancel(orderId) {
        return tslib_1.__awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", _cancel(api)(orderId, accountId));

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));
      }
    };
  };
}